module.exports = __webpack_public_path__ + "img/COB.9fffcb51.svg";